import {
	useForm,
	bindField,
	zPhoneNumber,
} from "@npco/zeller-design-system/form";
import * as Input from "@npco/zeller-design-system/input";
import { ADT } from "pb.adt";
import { z } from "zod";

import { Layout as ModalLayout } from "../../../shared/layout";
import type { Page } from "../page";
import { PaymentMethodLinkForm } from "./payment-method-link-form";

const ValuesSchema = z.object({
	phone: zPhoneNumber(),
});

export function PaymentMethodLinkSMS({
	page,
	defaultLayoutProps,
}: {
	page: Omit<ADT.Pick<Page, "PaymentMethodLinkSMS">, "$type">;
	defaultLayoutProps: ModalLayout.Defaults;
}) {
	const form = useForm(ValuesSchema, async ({ value }) => {
		await page.onSubmit(value.phone);
	});

	return (
		<PaymentMethodLinkForm
			page={page}
			defaultLayoutProps={defaultLayoutProps}
			form={form}
		>
			{(isSubmitting) => (
				<form.Field
					name="phone"
					children={(field) => (
						<Input.Phone
							{...bindField(field)}
							label="Mobile Number"
							disabled={isSubmitting}
						/>
					)}
				/>
			)}
		</PaymentMethodLinkForm>
	);
}
